import { useState } from "react";
import { useInterval } from "./use-interval";

export function useIntervalValue<T>(fn: () => T, timeout = 500) {
	const [value, setValue] = useState<T | null>(null);

	useInterval(() => {
		setValue(fn());
	}, timeout);

	/** Functions */
	function update() {
		setValue(fn());
	}

	return { value, update };
}
